<template>
    <div id="tags-view-container" class="tags-view-container">
        <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
            <router-link
                v-for="tag in visitedViews"
                ref="tag"
                :key="tag.path"
                :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
                tag="span"
                :class="isActive(tag) ? 'active' : ''"
                @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
            >
                <el-tag
                    class="tags-view-item"
                    :closable="!isAffix(tag)"
                    :type="isActive(tag) ? 'primary' : 'info'"
                    :color="isActive(tag) ? '' : '#fff'"
                    @close="!isAffix(tag) ? closeSelectedTag(tag) : ''">
                    {{ $t(tag.title) }}
                </el-tag>
            </router-link>
        </scroll-pane>
    </div>
</template>

<script>
import ScrollPane from './ScrollPane'

export default {
    name: 'TagsView',
    components: {ScrollPane},
    data() {
        return {
            visible: false,
            top: 0,
            left: 0,
            selectedTag: {},
            affixTags: [],
        }
    },
    computed: {
        visitedViews() {
            return this.$store.state.tagsView.visitedViews
        },
        routes() {
            return this.$store.state.user.sidebarRouters
        },
        theme() {
            return this.$store.state.settings.theme;
        }
    },
    watch: {
        $route() {
            this.addTags()
            this.moveToCurrentTag()
        },
    },
    mounted() {
        this.initTags()
        this.addTags()
    },
    methods: {
        filterAffixTags(routes, basePath = '/') {
            let tags = []
            routes.forEach(route => {
                if (route.meta && route.meta.affix) {
                    const tagPath = route.path
                    tags.push({
                        fullPath: tagPath,
                        path: tagPath,
                        name: route.name,
                        meta: {...route.meta}
                    })
                }
                if (route.children) {
                    const tempTags = this.filterAffixTags(route.children, route.path)
                    if (tempTags.length >= 1) {
                        tags = [...tags, ...tempTags]
                    }
                }
            })
            return tags
        },
        initTags() {
            const affixTags = this.affixTags = this.filterAffixTags(this.routes)
            for (const tag of affixTags) {
                if (tag.name) {
                    this.$store.dispatch('tagsView/addVisitedView', tag)
                }
            }
        },
        addTags() {
            const {name} = this.$route
            if (name) {
                this.$store.dispatch('tagsView/addView', this.$route)
                this.$emit('addTags', name)
            }
        },
        moveToCurrentTag() {
            const tags = this.$refs.tag
            this.$nextTick(() => {
                for (const tag of tags) {
                    if (tag.to.path === this.$route.path) {
                        this.$refs.scrollPane.moveToTarget(tag)
                        // when query is different then update
                        if (tag.to.fullPath !== this.$route.fullPath) {
                            this.$store.dispatch('tagsView/updateVisitedView', this.$route)
                        }
                        break
                    }
                }
            })
        },
        isActive(route) {
            return route.path === this.$route.path
        },
        isAffix(tag) {
            return tag.meta && tag.meta.affix
        },
        toLastView(visitedViews, view) {
            // 必然有一个affix的tag, 所以不用担心
            const latestView = visitedViews.slice(-1)[0]
            if (latestView) {
                this.$router.push(latestView.fullPath)
            } else {
                // now the default is to redirect to the home page if there is no tags-view,
                // you can adjust it according to your needs.
                if (view.name === 'Dashboard') {
                    // to reload home page
                    this.$router.replace({path: '/redirect' + view.fullPath})
                } else {
                    this.$router.push('/')
                }
            }
        },
        closeSelectedTag(view) {
            this.$tab.closePage(view).then(({visitedViews}) => {
                if (this.isActive(view)) {
                    this.toLastView(visitedViews, view)
                }
            })
        },
        closeMenu() {
            this.visible = false
        },
        handleScroll() {
            this.closeMenu()
        }
    }
}
</script>

<style lang="scss" scoped>
.tags-view-wrapper {
    padding: 3px;
    margin-top: 6px;
}

.tags-view-item {
    margin-left: 6px;
    cursor: pointer;
    user-select: none;
}
</style>
